import { http } from '@/http/axios.js'

export function getPosDataActiveAPI(params) {
  return http({
    url: `/api/admin/pos-data/active/page`,
    method: 'get',
    params
  })
}


export function getPosDataDealOrderAPI(params) {
  return http({
    url: `/api/admin/pos-data/dealOrder/page`,
    method: 'get',
    params
  })
}

export function getPosDataSimYearFeeAPI(params) {
  return http({
    url: `/api/admin/pos-data/simYearFee/page`,
    method: 'get',
    params
  })
}

